import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Menu, MenuItem } from "@mui/material";
import "./Navbar.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Navbar = () => {
  const [insuranceMenuAnchorEl, setInsuranceMenuAnchorEl] =
    useState<null | HTMLElement>(null);

  const handleInsuranceMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setInsuranceMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setInsuranceMenuAnchorEl(null);
  };

  return (
    <Box className="navbar px-4 py-3 bg-white fixed w-full top-0">
      <Grid
        container
        padding="0px 4px"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid xs maxWidth="192px">
          {/* <img
            src="./images/insurevent_logo.svg"
            alt="Insurvent"
            height="52px"
          /> */}
          <img src="./images/whitelogo.svg" alt="Insurvent" height="52px" />
        </Grid>
        <Grid
          xs
          textAlign="right"
          justifyContent="flex-end"
          alignItems="center"
        >
          <ul className="inline-flex items-center">
            <li className="mx-3">
              <Link>About Us</Link>
            </li>
            <li>
              <Button
                aria-controls="insurance-menu"
                aria-haspopup="true"
                onClick={handleInsuranceMenuClick}
              >
                Insurance <KeyboardArrowDownIcon />
              </Button>
              <Menu
                id="insurance-menu"
                anchorEl={insuranceMenuAnchorEl}
                open={Boolean(insuranceMenuAnchorEl)}
                onClose={handleMenuClose}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.2))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                MenuListProps={{
                  "aria-labelledby": "insurance-button",
                }}
              >
                <MenuItem onClick={handleMenuClose}>
                  Family Travel Insurance
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                  Group Travel Insurance
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                  Student Travel Insurance
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                  Multi-Trip Travel Insurance
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                  Single-Trip Travel Insurance
                </MenuItem>
              </Menu>
            </li>
            <li className="mx-3">
              <Link>Blog</Link>
            </li>
            <li>
              <Link>Contact us</Link>
            </li>
          </ul>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Navbar;
